// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statusClass {
  padding: 4px 8px;
  border-radius: 2px;
  color: #ffffff;
}
.customer-comp-list-ellipsis {
  white-space: nowrap;
  width: 130px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
}
.hasConfirm {
  background-color: #5cb85c;
}
.waitConfirm {
  background-color: #5cb85c;
}
.notConfirm {
  background-color: #337ab7;
}
.undefined {
  background-color: #5bc0de;
}
.newCreate {
  background-color: #b8b8b8;
}
.processing {
  background-color: #337ab7;
}
.completeOk {
  background-color: #5bc0de;
}
.comment {
  background-color: #5cb85c;
}
.normal {
  background-color: #5cb85c;
}
.warning {
  background-color: #ff1200;
}
.finish {
  background-color: #5cb85c;
}
.warningRed {
  background-color: #c03639;
}
.customer-complaint-list-modal-delete .ant-modal-content .ant-modal-body .ant-modal-confirm-content {
  font-weight: 600;
  padding-top: 20px;
}
.customer-complaint-list-modal-delete .ant-modal-content .ant-modal-confirm-btns {
  display: flex;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ClientList/HistoricalComplaints/HistoricalComplaintsNotClient/index.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;AACF;AAEA;EACE,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AAAF;AAGA;EACE,yBAAA;AADF;AAIA;EACE,yBAAA;AAFF;AAKA;EACE,yBAAA;AAHF;AAMA;EACE,yBAAA;AAJF;AAOA;EACE,yBAAA;AALF;AAQA;EACE,yBAAA;AANF;AASA;EACE,yBAAA;AAPF;AAUA;EACE,yBAAA;AARF;AAWA;EACE,yBAAA;AATF;AAYA;EACE,yBAAA;AAVF;AAYA;EACE,yBAAA;AAVF;AAYA;EACE,yBAAA;AAVF;AAYA;EAIQ,gBAAA;EACA,iBAAA;AAbR;AAQA;EASM,aAAA;EACA,uBAAA;AAdN","sourcesContent":[".statusClass {\n  padding: 4px 8px;\n  border-radius: 2px;\n  color: #ffffff;\n}\n\n.customer-comp-list-ellipsis {\n  white-space: nowrap;\n  width: 130px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  display: block;\n}\n\n.hasConfirm {\n  background-color: #5cb85c;\n}\n\n.waitConfirm {\n  background-color: #5cb85c;\n}\n\n.notConfirm {\n  background-color: #337ab7;\n}\n\n.undefined {\n  background-color: #5bc0de;\n}\n\n.newCreate {\n  background-color: #b8b8b8;\n}\n\n.processing {\n  background-color: #337ab7;\n}\n\n.completeOk {\n  background-color: #5bc0de;\n}\n\n.comment {\n  background-color: #5cb85c;\n}\n\n.normal {\n  background-color: #5cb85c;\n}\n\n.warning {\n  background-color: #ff1200;\n}\n.finish {\n  background-color: #5cb85c;\n}\n.warningRed {\n  background-color: #c03639;\n}\n.customer-complaint-list-modal-delete {\n  .ant-modal-content {\n    .ant-modal-body {\n      .ant-modal-confirm-content {\n        font-weight: 600;\n        padding-top: 20px;\n      }\n    }\n    .ant-modal-confirm-btns {\n      display: flex;\n      justify-content: center;\n    }\n  }\n}\n\n@primary-color: #FABF00;@input-placeholder-color: #868686;@btn-primary-color: #454545;@checkbox-check-color: #454545;@checkbox-color: #E8AA0D;@radio-button-bg: #E8AA0D;@radio-button-checked-bg: #E8AA0D;@radio-button-color: #454545;@radio-button-active-color: #454545;@radio-solid-checked-color: #454545;@font-family: 'WenQuanYi Micro Hei', 'Micro Hei','Noto Sans CJK','Source Han Sans','Montserrat','Roboto','Lato','sans-serif';@btn-text-shadow: 0 0 0 rgba(0, 0, 0, 0);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
